import { SxProps, Theme } from "@mui/material/styles";
import theme, { erreur, gris2 } from "../../theme";

const styles: SxProps<Theme> = [
  {
    "&.root, & .root": {
      width: "100%",
      fontWeight: 600,
      fontSize: "0.8rem",
      "&:hover .textField": {
        backgroundColor: theme.palette.common.white,
      },
    },
    "& .textFieldRoot": {
      border: "1px solid " + theme.palette.primary.main,
    },
    "& .textField": {
      backgroundColor: theme.palette.common.white,
      borderRadius: "0",
      padding: "14px 12px 7px",
      fontSize: "0.9rem",
      fontWeight: "600",
    },
    "& .textFieldLabelFocused": {},
    "& .textFieldLabelError": {},
    "& .textFieldLabelAsterisk": {
      "&.textFieldLabelError": {
        color: theme.palette.common.black,
      },
    },
    "& .textFieldLabel": {
      fontWeight: "bold",
      fontSize: "0.8rem",
      color: theme.palette.common.black,
      transform: "translate(12px, 12px) scale(1)",
      "&$textFieldLabelFocused": {
        fontWeight: "normal",
        color: theme.palette.common.black,
      },
      "&.textFieldLabelError": {
        color: theme.palette.common.black,
      },
      "&.MuiInputLabel-shrink": {
        transform: "translate(12px, 4px) scale(0.75)",
        fontSize: "1em",
        fontWeight: "normal",
        color: theme.palette.grey[400],
      },
    },
    "& .errorMessage": {
      color: erreur,
    },
    "& .underline": {
      background: theme.palette.common.white,
      "&::before, &::after": {
        borderBottomWidth: "0",
      },
      ":hover": {
        background: theme.palette.common.white,
      },
    },
    "&.counterRoot": {
      display: "flex",
      flexDirection: "row",
    },
    "& .counterTextField": {
      width: "2.5rem",
    },
    "& .textFieldCounter": {
      padding: "11px 8px",
      textAlign: "center",
      background: "white",
    },
    "& .counterLabel": {
      position: "relative",
      transform: "none",
      display: "flex",
      alignItems: "center",
      margin: "0 12px",
      color: theme.palette.common.black,
      fontWeight: "bold",
      fontSize: "0.8rem",
    },
    "& .buttonCounter": {
      background: theme.palette.primary.main,
      color: "#FFF",
      borderRadius: "0",
      border: "none",
      width: 40,
      minWidth: 40,
      "&:hover": {
        backgroundColor: gris2,
      },
      "& svg": {
        color: "#FFF",
      },
    },

    "& .caption": {
      fontStyle: "italic",
    },
    "& .inputPassword": {
      background: "#FFF",
      "&:hover": {
        background: "#FFF",
      },
    },
    "& .showPassword": {
      padding: "4px",
      "&:hover": {
        background: "none",
        color: "#444",
      },
    },
    "& .Mui-disabled": {
      opacity: 0.6,
      "& input": { color: "black", "-webkit-text-fill-color": "black" },
    },
  },
];

export default styles;
